module.exports = __webpack_public_path__ + "img/woodStand-9.012a56e5.png";